export default () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.985352" width="32" height="32" fill="white" fillOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.70683 6.68039H25.2919C27.515 6.68039 29.3327 8.5008 29.3327 10.7212V23.2491C29.3327 25.4695 27.515 27.2899 25.2919 27.2899H6.70683C4.4837 27.2899 2.66602 25.4695 2.66602 23.2491V10.7212C2.66602 8.5008 4.4837 6.68039 6.70683 6.68039ZM21.7164 9.64638C22.8592 9.64638 23.7844 10.5715 23.7844 11.7144C23.7844 12.8573 22.8592 13.7852 21.7164 13.7852C20.5735 13.7852 19.6456 12.8573 19.6456 11.7144C19.6456 10.5715 20.5735 9.64638 21.7164 9.64638ZM8.38846 20.9607L13.1368 13.2518C13.534 12.7947 14.4347 12.7947 14.832 13.2518L17.915 18.2532L19.1368 16.2695C19.4198 15.943 20.0592 15.943 20.3422 16.2695L23.7136 21.7443C24.3504 22.7783 23.6783 24.0464 22.5517 24.0464C18.3749 24.0464 14.198 24.0464 10.0211 24.0464C8.4184 24.0464 7.49051 22.4164 8.38846 20.9607Z"
      fill="currentColor"
    />
  </svg>
);
